.header {
  position: sticky;
  top: 0;
  width: 100%;
  background-color: var(--primary);
  color: var(--white);
  z-index: var(--z-fixed);
  transition: all 0.3s ease;
}

.scrolled {
  background-color: var(--bg-primary);
  color: var(--text-primary);
  box-shadow: var(--shadow);
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 var(--space-4);
  height: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Logo Styles - Updated */
.logoContainer {
  display: flex;
  align-items: center;
}

.logoLink {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: inherit;
}

/* Desktop Navigation */
.desktopNav {
  display: none;
}

.navLink {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-4);
  color: inherit;
  text-decoration: none;
  font-weight: 500;
  border-radius: var(--radius-full);
  transition: all 0.2s;
}

.navLink.active {
  background-color: rgba(255, 255, 255, 0.2);
}

.navLink:hover:not(.active) {
  background-color: rgba(255, 255, 255, 0.1);
}

.scrolled .navLink.active {
  background-color: var(--primary-light);
  color: var(--primary);
}

.scrolled .navLink:hover:not(.active) {
  background-color: var(--gray-100);
}

/* Authentication Buttons */
.authContainer {
  display: none;
}

.authButtons {
  display: flex;
  gap: var(--space-3);
}

.loginButton, .signupButton {
  padding: var(--space-2) var(--space-4);
  font-weight: 500;
  text-decoration: none;
  border-radius: var(--radius);
  transition: all 0.2s;
}

.loginButton {
  color: var(--white);
}

.scrolled .loginButton {
  color: var(--text-primary);
}

.loginButton:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.scrolled .loginButton:hover {
  background-color: var(--gray-100);
}

.signupButton {
  background-color: var(--white);
  color: var(--primary);
}

.scrolled .signupButton {
  background-color: var(--primary);
  color: var(--white);
}

.signupButton:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

/* User Menu */
.userMenuContainer {
  position: relative;
}

.userMenuButton {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-3);
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  border-radius: var(--radius);
  transition: all 0.2s;
}

.userMenuButton:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.scrolled .userMenuButton:hover {
  background-color: var(--gray-100);
}

.userAvatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: var(--primary-light);
  color: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}

.scrolled .userAvatar {
  background-color: var(--primary);
  color: var(--white);
}

.userName {
  font-weight: 500;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chevron {
  transition: transform 0.2s;
}

.rotated {
  transform: rotate(180deg);
}

.userMenu {
  position: absolute;
  top: calc(100% + var(--space-2));
  right: 0;
  width: 260px;
  background-color: var(--bg-primary);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  overflow: hidden;
  z-index: var(--z-dropdown);
  animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.userInfo {
  padding: var(--space-4);
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

.userFullName {
  font-weight: 600;
  margin: 0;
  color: var(--text-primary);
}

.userEmail {
  margin: 0;
  font-size: 0.875rem;
  color: var(--text-secondary);
}

.menuDivider {
  height: 1px;
  background-color: var(--gray-200);
  margin: 0;
}

.menuItem, .signOutButton {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  color: var(--text-primary);
  font-size: 1rem;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s;
}

.menuItem:hover, .signOutButton:hover {
  background-color: var(--gray-100);
}

.signOutButton {
  color: var(--danger);
}

/* Mobile Menu Button & Menu */
.mobileMenuButton {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  width: 40px;
  height: 40px;
}

.mobileMenu {
  background-color: var(--bg-primary);
  padding: var(--space-4);
  box-shadow: var(--shadow);
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.mobileNav {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.mobileNavLink {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-3);
  color: var(--text-primary);
  text-decoration: none;
  font-weight: 500;
  border-radius: var(--radius);
  transition: background-color 0.2s;
}

.mobileNavLink:hover {
  background-color: var(--gray-100);
}

.mobileAuthButton {
  display: block;
  margin-top: var(--space-3);
  padding: var(--space-3);
  background-color: var(--primary);
  color: white;
  border-radius: var(--radius);
  text-align: center;
  font-weight: 500;
  text-decoration: none;
}

.mobileSignOutButton {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-3);
  background: none;
  border: none;
  color: var(--danger);
  font-size: 1rem;
  text-align: left;
  cursor: pointer;
  width: 100%;
  border-radius: var(--radius);
}

.mobileSignOutButton:hover {
  background-color: var(--gray-100);
}

/* Media Queries */
@media (min-width: 640px) {
  .logoText {
    display: block;
  }
}

@media (min-width: 768px) {
  .container {
    height: 80px;
  }
  
  .desktopNav {
    display: flex;
    align-items: center;
    gap: var(--space-2);
  }
  
  .authContainer {
    display: block;
  }
  
  .mobileMenuButton {
    display: none;
  }
}

@media (min-width: 1024px) {
  .container {
    padding: 0 var(--space-5);
  }
  
  .desktopNav {
    gap: var(--space-4);
  }
}
